import IconCross from 'assets/icons/cross.svg';
import Button from 'components/button';
import Modal from 'components/modal';
import { useConfig } from 'config/use-config';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

interface PropTypes {
  isOpen: boolean;
  insufficientMoney: number;
  onClose: () => any;
}

const MbvModal: React.FC<PropTypes> = ({ insufficientMoney, isOpen, onClose }) => {
  const intl = useIntl();
  const { currencyCode } = useConfig();
  const insufficientMoneyFormatted = intl.formatNumber(insufficientMoney, {
    style: 'currency',
    currency: currencyCode,
  });

  return (
    <Modal
      className="max-w-3xl p-4 md:p-6 lg:p-8 xl:p-10"
      style={{
        backgroundColor: '#B8DAF5',
      }}
      onRequestClose={onClose}
      isOpen={isOpen}
    >
      <button
        className="absolute top-4 right-4 z-20 p-2 opacity-50 hover:opacity-100 focus:outline-hidden"
        onClick={onClose}
        aria-label="Schließen"
      >
        <IconCross className="text-text-dark-bg-contrast-white h-5 w-5" />
      </button>
      <div className="flex justify-between">
        <div className="flex flex-col md:w-1/2">
          <h2 className="pb-4 text-lg leading-tight font-medium lg:text-xl xl:text-3xl">
            <FormattedMessage id="cart:mbv:modal:title" />
          </h2>

          <FormattedMessage
            id="cart:mbv:modal:description"
            values={{
              insufficientMoney: insufficientMoneyFormatted,
              p: (chunks) => <p>{chunks}</p>,
              b: (chunks) => <b>{chunks}</b>,
              br: <br />,
            }}
          />

          <Button href="/" layout="white" className="mt-4">
            <FormattedMessage id="cart:mbv:modal:cta" />
          </Button>
        </div>
        <div className="relative hidden w-1/2 md:block">
          <img
            className="absolute top-1/2 left-0 ml-10 h-auto -translate-y-1/2 transform"
            alt=""
            style={{ minWidth: '450px' }}
            src={'/images/cart/mbv/product-bg.jpg'}
          />
        </div>
      </div>
    </Modal>
  );
};

export default MbvModal;
